<template>
	<form @submit.prevent="logout">
		<input type="submit" name="submit" value="Logout">
	</form>
</template>

<script>
    export default {
        name: "logout",
		methods:{
            logout(){
                axios.post('/logout').then(()=>{
					window.location.replace("/");
				})
			}
		}
    }
</script>

<style scoped>

</style>